<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// Main app component
</script>

<style>
#app {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
